import { Text, View } from 'components';
import Base, { Config } from 'components/Base';
import React from 'react';
import styles from './index.module.scss';

export default class ScoresRule extends Base {
  public config: Config = {
    navigationBarTitleText: '积分规则'
  };

  public render() {
    return (
      <View className={styles.container}>
        <Text className={styles.title}>积分使用规则:</Text>
        <View className={styles.card}>
          <Text className={styles.cardTitle}>拨打招聘电话</Text>
          <View className={styles.cardContentContainer}>
            <Text className={styles.cardContentText}>
              拨打铲车招聘电话，每次消耗5积分；
            </Text>
            <Text className={styles.cardContentText}>
              拨打9000以下招聘电话，每次消费5积分；
            </Text>
            <Text className={styles.cardContentText}>
              拨打9000~10000挖机招聘电话，每次消耗8积分；
            </Text>
            <Text className={styles.cardContentText}>
              拨打10000~11000挖机招聘电话，每次消耗12积分；
            </Text>
            <Text className={styles.cardContentText}>
              拨打11000以上挖机招聘电话，每次消耗18积分；
            </Text>
          </View>
        </View>
        <View className={this.cx(styles.card, styles.noBorder)}>
          <Text className={styles.cardTitle}>拨打简历电话</Text>
          <View className={styles.cardContent}>
            <Text className={styles.cardContentText}>
              拨打简历电话，每次消耗5积分
            </Text>
          </View>
        </View>
        <View className={styles.divider} />
        <Text className={styles.title}>积分获取规则:</Text>
        <View className={styles.card}>
          <View className={styles.cardContent}>
            <Text className={styles.cardContentText}>成功邀请</Text>
            <Text className={styles.cardContentEmText}>1名</Text>
            <Text className={styles.cardContentText}>新用户后</Text>
            <Text className={styles.cardContentEmText}>获得5积分</Text>
          </View>
        </View>
        <View className={styles.card}>
          <View className={styles.cardContent}>
            <Text className={styles.cardContentText}>新用户免费</Text>
            <Text className={styles.cardContentEmText}>赠送5积分</Text>
          </View>
        </View>
      </View>
    );
  }
}
